
import Actions from '../actions';
import PropTypes from 'prop-types';
import React from 'react';
import {Helmet} from 'react-helmet';
import {Link} from 'react-router-dom';
import Store from './store';
import FromHash from './../../../../helpers/url-hash';


const propTypes = {
  match: PropTypes.object,
};

class LoginConfirmPage extends React.Component {
  constructor(props) {

    super(props);

    this.input = {};
    this.state = Store.getState();

  }

  componentDidMount() {

    this.unsubscribeStore = Store.subscribe(this.onStoreChange.bind(this));

    if (this.input.key) {
      this.input.key.focus();
    }

    const hashValues = FromHash(['email', 'key']);

    const email = hashValues.email || this.props.match.params.email || '';
    const key = hashValues.key || this.props.match.params.key || '';

    if (email && key){
      this.confirmEmail(email, key);
    }

  }

  componentWillUnmount() {
    this.unsubscribeStore();
    Actions.resetStore();
  }

  onStoreChange() {
    this.setState(Store.getState());
  }

  confirmEmail(email, key) {
    Actions.confirmEmail({
      email: email,
      key: key,
    });
  }

  render() {

    const { success, validation } = this.state;

    return (
      <section className="container">
        <Helmet>
          <title>Verify Your Email Address</title>
        </Helmet>

        <div className="login-header px-3 py-3 pt-md-5 pb-md-4 mx-auto text-center">
          <h1 className="display-4">Verify Your Email</h1>
        </div>

        <div className="container">
          <p className="text-center">Look out for an email from api@coinmarketcap.com with a confirmation link.<br/>Follow the link in the email. <a href="/login/forgot">Didn't get an email?</a></p>
          <div className="row">
            <div className="col-6 offset-3 text-center">
              {(!!success) && (
                <div>
                  <div className="alert alert-success">
                    Your new email address is now confirmed!<br/>
                    Please log in to access your API Key.
                  </div>
                  <Link to="/login" className="btn btn-link">Back to login</Link>
                </div>
              )}

              {(!!validation.error) && (
                <div className="alert alert-danger">
                  {this.state.validation.error}
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    );
  }
}

LoginConfirmPage.propTypes = propTypes;

export default LoginConfirmPage;



// WEBPACK FOOTER //
// ./client/pages/main/login/confirm/index.jsx